<template>
  <div>
    <ValidationProvider
      v-slot="{ errors }"
      rules="required"
      :name="$t('cards.add.card_name')"
      slim
    >
      <div
        class="form-group"
        :class="{'has-error': errors.length}"
      >
        <label
          for="cardName"
          class="control-label"
        >
          {{ $t('cards.add.card_name') }}
        </label>
        <PortalTooltip
          tip-id="cardNameHelp"
          :text="$t('login.create_account.hints.card_name')"
        />
        <input
          id="cardName"
          :value="value.name"
          name="card-name"
          class="form-control"
          type="text"
          :disabled="processingForm"
          :placeholder="$t('cards.add.card_name')"
          @input="update('name', $event.target.value)"
        >
        <span
          class="help-block"
          role="alert"
        >
          <i
            v-if="errors.length"
            class="fa fa-warning"
          />{{ errors[0] }}
        </span>
      </div>
    </ValidationProvider>

    <ValidationProvider
      v-slot="{ errors }"
      rules="required|alpha_num|min:13|max:14"
      :name="$t('cards.payments_history.service_reference_id')"
      slim
    >
      <div
        class="form-group"
        :class="{'has-error': errors.length}"
      >
        <label
          for="srfid"
          class="control-label"
        >
          {{ $t('cards.payments_history.service_reference_id') }}
        </label>
        <PortalTooltip
          tip-id="srfidHelp"
          :text="$t('login.create_account.hints.srid')"
          image="/img/hint-SRFID.png"
        />
        <input
          id="srfid"
          :value="value.srfid"
          name="srfid"
          class="form-control"
          type="text"
          :disabled="processingForm"
          :placeholder="$t('cards.payments_history.service_reference_id')"
          @input="update('srfid', $event.target.value)"
        >
        <span
          class="help-block"
          role="alert"
        >
          <i
            v-if="errors.length"
            class="fa fa-warning"
          />{{ errors[0] }}
        </span>
      </div>
    </ValidationProvider>

    <ValidationProvider
      v-slot="{ errors }"
      rules="required|money:2"
      :name="$t('cards.add.amount')"
      slim
    >
      <div
        class="form-group"
        :class="{'has-error': errors.length}"
      >
        <label
          class="control-label"
          for="amount"
        >
          {{ $t('cards.add.amount') }}
        </label>
        <PortalTooltip
          tip-id="amountHelp"
          :text="$t('login.create_account.hints.amount')"
          image="/img/hint-amount.png"
        />
        <input
          id="amount"
          :value="value.amount"
          name="amount"
          class="form-control"
          :disabled="processingForm"
          :placeholder="$t('cards.add.amount')"
          inputmode="decimal"
          @input="update('amount', $event.target.value)"
        >
        <span
          class="help-block"
          role="alert"
        >
          <i
            v-if="errors.length"
            class="fa fa-warning"
          />{{ errors[0] }}
        </span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import {ValidationProvider, extend} from 'vee-validate'
import {required, alpha_num, max, min} from 'vee-validate/dist/rules'
import {money} from '@/mixins/form/validator'
import PortalTooltip from '@/components/PortalTooltip'

extend('required', required)
extend('alpha_num', alpha_num)
extend('money', money)
extend('max', max)
extend('min', min)

export default {
  components: {PortalTooltip, ValidationProvider},
  props: {
    value: {
      type: Object,
      required: true
    },
    processingForm: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    update(key, name) {
      this.$emit('input', {...this.value, [key]: name})
    }
  }
}
</script>
